import {Divider, IconButton, List, ListItem, ListItemIcon, ListItemText, Typography} from '@mui/material';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import DescriptionIcon from '@mui/icons-material/Description';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DownloadIcon from '@mui/icons-material/Download';
import {CreditRequestModel} from '../../../model/credit/credit-request.model';
import {CreditSupportPageHooks} from '../state/credit-support-page-hooks';

type Props = {
  isDrawerOpen: boolean
  onDrawerClosed: () => void
  request: CreditRequestModel
  translate: (key: string) => string
}

const getFileIcon = (contentType: string) => {
  if (contentType.includes('pdf')) return <PictureAsPdfIcon color="error"/>
  if (contentType.startsWith('image/')) return <ImageIcon color="primary"/>
  if (contentType.includes('word') || contentType.includes('officedocument.wordprocessingml')) return <DescriptionIcon color="action"/>
  return <InsertDriveFileIcon/>
}

export const CreditRequestAttachmentDrawer = ({isDrawerOpen, onDrawerClosed, request, translate}: Props) => {
  const [attachments] = CreditSupportPageHooks.useCreditRequestAttachments(request.id)

  const handleOpen = (url: string) => window.open(url, '_blank', 'noopener,noreferrer')

  return <Drawer
    anchor="right"
    open={isDrawerOpen}
    onClose={onDrawerClosed}
    PaperProps={{
      sx: {
        width: '50%',
        marginTop: '64px',
        height: 'calc(100% - 64px)',
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto'
      }
    }}
  >
    <Typography variant="h6">{request.title}</Typography>
    <Typography variant="caption">{request.organizationName} / {request.accountName}</Typography>
    <Divider sx={{my: 2}}/>
    {
      attachments.length === 0
        ? <Box p={2} display="flex" justifyContent="center" color="text.secondary">
          <Typography variant="body2">{translate('common.empty.title') || 'Brak załączników'}</Typography>
        </Box>
        : <List dense>
          {attachments.map((file) => (
            <ListItem
              key={file.id}
              divider
              secondaryAction={
                <IconButton edge="end" aria-label="download" onClick={() => handleOpen(file.url)}>
                  <DownloadIcon/>
                </IconButton>
              }
            >
              <ListItemIcon>{getFileIcon(file.contentType)}</ListItemIcon>
              <ListItemText primary={file.fileName}/>
            </ListItem>
          ))}
        </List>
    }
  </Drawer>
}
